import { TextInput } from 'react-admin';
import FileManagerModalInput from '../FileManagerModalInput';
import ArrayForm from './ArrayForm';
import BoundedInput from './BoundedInput';

const ArrayDownload = ({ index, source, }: { source: string, index: number }) => {
    return (
        <ArrayForm source={source} grid={0} simpleFormIteratorProps={{
            sx: {
                '& .RaSimpleFormIterator-form': {
                    display: 'grid',
                    gap: '0px',
                    columnGap: '10px',
                    gridTemplateAreas: `'file file file' 'name_en name_tc name_sc'`
                }
            }
        }}>
            <BoundedInput source={`file`} input={<FileManagerModalInput source="dummy" mode="file" />} />
            <BoundedInput source={`name_en`} input={<TextInput source="dummy" />} />
            <BoundedInput source={`name_tc`} input={<TextInput source="dummy" />} />
            <BoundedInput source={`name_sc`} input={<TextInput source="dummy" />} />
        </ArrayForm>
    )
}

export default ArrayDownload;